<template>
    <div class="crud-wrapper">
      <crud :filterBy="{filters: dataFilter}" :grid-columns="gridColumns" :form-component="ContractForm"
        alwaysUpdate="typeId,bankId,amount,term,netAmount" :gridSettings="{noNew: true, noRefresh: true, noSearch: false, noExport: false, noChooser: true, noGroup: true, multiSelectable: false}"
            :grid-options="gridOptions" :key="reRender" obj="campaignLeads" ref="crud">
      </crud>
   </div>
</template>
<script>
    import numeral from 'numeral';
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
    import ContractForm from './ContractForm';

    export default PageClass.extend({
        name: 'Contracts',

        watch: {
            async kind (newValue) {
                await this.init();
                this.reRender = +new Date();
            }
        },

        data () {
            return {
                ContractForm,
                reRender: 0,
                gridColumns: null,
                gridOptions: {
                    selection: {
                        mode: 'none'
                    },
                },
                dataFilter: {},
                campaignLeads: [],
            };
        },

        async created () {
            this.init();
        },

        methods: {
            pageFiltersChange (filters) {
                this.dataFilter = {
                    productTypeId: filters.productTypeId ? filters.productTypeId : null,
                    affiliateId: filters.affiliateId ? filters.affiliateId : null,
                    campaignId: filters.campaignId ? filters.campaignId : null
                };
            },

            async init () {
                this.gridColumns = [
                    {
                        dataField: 'name',
                        caption: 'Cliente',
                        minWidth: 150
                    },
                    {
                        dataField: 'federalId',
                        caption: 'CPF',
                        minWidth: 70,
                        cellTemplate: (element, info) => {
                            let f = this.$util.applyMask(info.data.federalId, '999.999.999-99');
                            $(`<span>${f}</span>`).appendTo(element);
                        }
                    },
                    {
                        dataField: 'birth',
                        caption: 'Nascido em',
                        dataType: 'date',
                        format: 'dd/MM/yyyy',
                        width: 120
                    },
                    {
                        dataField: 'createdAt',
                        caption: 'Criado em',
                        dataType: 'date',
                        format: 'dd/MM/yyyy hh:mm',
                        minWidth: 90
                    },
                    {
                        dataField: 'stateFlow',
                        caption: 'Estado no Fluxo',
                        minWidth: 80,
                    },
                    {
                        dataField: 'status',
                        caption: 'Status Atual',
                        minWidth: 100
                    },
                    {
                        dataField: 'production',
                        caption: 'Produção',
                        alignment: 'left',
                        dataType: 'number',
                        format: function (value) {
                            return 'R$ ' + numeral(value).format('0,0.' + '0'.repeat(2));
                        }
                    },
                ];

                if (!this.hasPageFilters) {
                    this.createPageFilters([
                        { field: 'productTypeId' },
                        { field: 'affiliateId' },
                        { field: 'campaignId' }
                    ]);

                } else {
                    let filters = this.$store.getters.activePageFilters;
                    this.dataFilter = {
                        productTypeId: filters.productTypeId || null,
                        affiliateId: filters.affiliateId || null,
                        campaignId: filters.campaignId || null
                    };

                }
            }
        }
    });

</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/CampaignLeads.vue